export default "__VITE_ASSET__BVM4xHmL__"